import React, {useState} from 'react'
import {FaBars, FaTimes, FaGithub, FaLinkedin, FaFacebook} from 'react-icons/fa'
import {IoSend, IoDocument} from 'react-icons/io5'
import {HiOutlineMail} from 'react-icons/hi'
import {BsFillPersonLinesFill} from 'react-icons/bs'
import Logo from "../assets/Logo.jpg"
import Resume from "../assets/Resume.pdf"


const Navbar = () => {
    const [nav, setNav] = useState(false)
    const handleClick = () => setNav(!nav)

  return (
    <div className='sticky top-0 w-full h-[80px] flex justify-center items-center px-4 text-gray-300 bg-gradient-to-tr from-[#010000] to-[#020933] sm:justify-between'>
        <div>
            <h1 className='w-16 h-16 bg-gradient-to-tr from-[#350a3d] to-[#020933] rounded-2xl justify-center items-center text-3xl outline outline-[2px] hidden sm:flex'>RH</h1>
            {/* <img src={Logo} alt="RH Logo" className=' w-16' /> */}
        </div>

        {/* menu */}
        <ul className='flex w-full justify-between lg:hidden sm:gap-[5px] sm:justify-end'>
            <li className='h-[60px] flex justify-between items-center'>
                <a className='flex items-center w-full text-gray-300 hover:brightness-125 enlarge' href="https://www.linkedin.com/in/rhorvath2002" target='_blank'>
                    <FaLinkedin size={30} />
                </a>
            </li>
            <li className='h-[60px] flex items-center'>
                <a className='flex items-center w-full text-gray-300 hover:brightness-125 enlarge' href="https://www.github.com/rhorvath02" target='_blank'>
                    <FaGithub size={30} />
                </a>
            </li>
            <li className='h-[60px] flex items-center'>
                <a className='flex items-center w-full text-gray-300 hover:brightness-125 enlarge' href={Resume} target='_blank'>
                    <IoDocument size={30} />
                </a>
            </li>
            <li className='h-[60px] flex items-center'>
                <a className='flex items-center w-full text-gray-300 hover:brightness-125 enlarge' href="https://www.linkedin.com/in/rhorvath2002" target='_blank'>
                    <IoSend size={30} />
                </a>
            </li>
        </ul>

        <ul className='hidden lg:flex'>
            <li><h1 className='underline-transition'>Home</h1></li>
            <li><h1 className='underline-transition'>About</h1></li>
            <li><h1 className='underline-transition'>Experience</h1></li>
            {/* <li className='highlight-transition'>Skills</li> */}
            <li><h1 className='underline-transition'>Contact</h1></li>
        </ul>

        {/* hamburger */}
        {/* <div onClick={handleClick} className='md:hidden z-10'>
            {!nav ? <FaBars /> : <FaTimes />}
        </div> */}

        {/* mobile menu */}
        {/* <ul className={!nav ? 'hidden' : 'absolute top-0 left-0 w-full h-screen bg-gradient-to-tr from-[#010000] to-[#020933] flex flex-col justify-center items-center'}>
            <li className='py-6 text-4xl'>Home</li>
            <li className='py-6 text-4xl'>About</li>
            <li className='py-6 text-4xl'>Experience</li>
            <li className='py-6 text-4xl'>Skills</li>
            <li className='py-6 text-4xl'>Contact</li>
        </ul> */}

        {/* social icons */}
        <div className='hidden lg:flex fixed flex-col top-[calc(50%-180px/2)] left-0'>
            <ul>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-gradient-to-tr from-[#350a3d] to-[#020933]'>
                    <a className='flex justify-between items-center w-full text-gray-300' href="https://www.linkedin.com/in/rhorvath2002" target='_blank'>
                        Linkedin <FaLinkedin size={30} />
                    </a>
                </li>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-gradient-to-tr from-[#350a3d] to-[#020933]'>
                    <a className='flex justify-between items-center w-full text-gray-300' href="https://www.github.com/rhorvath02" target='_blank'>
                        Github <FaGithub size={30} />
                    </a>
                </li>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-gradient-to-tr from-[#350a3d] to-[#020933]'>
                    <a className='flex justify-between items-center w-full text-gray-300' href={Resume} target='_blank'>
                        Resume <IoDocument size={30} />
                    </a>
                </li>
            </ul>
        </div>

    </div>
  )
}

export default Navbar